// extracted by mini-css-extract-plugin
export default {"title":"_98e759e7bb","inner_title":"d792402901","charge_btn":"_00e523f095"};